module.exports = __webpack_public_path__ + "img/edge_restauration_bouteille.b38e1de1.svg";